import { Col, Container, Row } from 'react-bootstrap';
import trust from '../../images/trust.png';

export default function HomeTrustDatagenetx() {
  return (
    <Container fluid className="w-100 mt-5">
      <div className="container hometrust-container">
        <h2>Trust Datagenetx with your Data</h2>
        <Row>
          <Col xl={7}>
            <p>
              Your customers will want our emails and you will get paid for it.
              We understand mailing, have mailed for 10+ years, and are fully
              CAN-SPAM compliant. Our account reps will go over our mailing
              strategy with you and make sure you feel comfortable before
              sending the first email. We will interact with your customers in a
              way that they benefit from while producing top dollar per email
              record.
            </p>
          </Col>
          <Col xl={4} className="ms-5">
            <img src={trust} alt="trust" style={{ width: '200px' }} />
          </Col>
        </Row>
      </div>
    </Container>
  );
}
